import {insertImage} from "../../plugins/imageUploadPlugin";
import {toggleMark} from "prosemirror-commands";
import {getLinkAttrsAtSelection, normalizeUrl} from "../../helpers/link";

export function isMarkActive(state, markType) {
    const {from, $from, to, empty} = state.selection;
    if (empty) {
        return !!markType.isInSet(state.storedMarks || $from.marks());
    }
    return state.doc.rangeHasMark(from, to, markType);
}

export function isSelectionLink(state) {
    const link = state.schema.marks.link;
    if (!link) return false;
    const {$from, empty, from, to} = state.selection;
    if (empty) {
        return !!link.isInSet(state.storedMarks || $from.marks());
    }
    let found = false;
    state.doc.nodesBetween(from, to, (node) => {
        if (found || !node.isText) return;
        if (link.isInSet(node.marks)) {
            found = true;
        }
    });
    return found;
}

export function applyLink(state, dispatch, href) {
    const link = state.schema.marks.link;
    if (!link || !href) return false;
    const normalized = normalizeUrl(href);
    if (!normalized) return false;
    // Apply link mark to selection
    return toggleMark(link, {href: normalized})(state, dispatch);
}

export function removeLink(state, dispatch) {
    const link = state.schema.marks.link;
    if (!link) return false;
    return toggleMark(link, {})(state, dispatch);
}

function getCurrentBlockType(state) {
    const {$from} = state.selection;
    const node = $from.parent;
    return {type: node.type, attrs: node.attrs};
}

export function getCurrentHeadingLevel(state) {
    const {type, attrs} = getCurrentBlockType(state);
    if (type.name === "heading" && attrs.level) {
        return attrs.level;
    }
    return 0; // 0 means not a heading (paragraph or other block)
}

export function insertTable(state, dispatch) {
    const {schema} = state;
    const tableNode = schema.nodes.table;
    const rowNode = schema.nodes.table_row;
    const cellNode = schema.nodes.table_cell;

    if (!tableNode || !rowNode || !cellNode) return false;

    const cells = [];
    for (let i = 0; i < 3; i++) {
        cells.push(cellNode.createAndFill());
    }
    const rows = [];
    for (let i = 0; i < 3; i++) {
        rows.push(rowNode.create(null, cells));
    }

    const table = tableNode.create(null, rows);

    if (dispatch) {
        const tr = state.tr.replaceSelectionWith(table);
        dispatch(tr.scrollIntoView());
    }
    return true;
}

export function canRunCommand(view, cmd) {
    if (!view) return false;
    try {
        return cmd(view.state, null, view);
    } catch {
        return false;
    }
}

export function runCommand(view, cmd) {
    if (!view) return;
    cmd(view.state, view.dispatch, view);
    view.focus();
}

export function handleImageUpload(view, provider, fileInputRef) {
    if (!fileInputRef.current) return;

    const file = fileInputRef.current.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
        alert("Please select an image file");
        return;
    }

    insertImage(view, file, provider);
    fileInputRef.current.value = "";
}

export function getSelectedLinkAttrs(state) {
    return getLinkAttrsAtSelection(state);
}
